import React, { useState } from 'react'
import { BiSearch, BiNotification, BiX } from 'react-icons/bi'
import "./content.css"
import { useGetPendingTicketsQuery } from '../../services/ticket.api.ts'

const ContentHeader = ({ children }) => {
  const [isPopupVisible, setIsPopupVisible] = useState(false)
  const { data: ticketList, isLoading, isError } = useGetPendingTicketsQuery()

  const togglePopup = () => {
    setIsPopupVisible(!isPopupVisible)
  }

  return (
    <>
      <div className="content--header">
        <h1 className="header--title">{children}</h1>
        <div className="header--activity">
          <div className="search-box">
            <input type="text" placeholder='Search anything here...' />
            <BiSearch className='icon' />
          </div>

          <div className="notify" onClick={togglePopup}>
            <BiNotification className='icon'/>
          </div>
        </div>
      </div>

      {isPopupVisible && (
        <div className="notification-popup-overlay">
          <div className="notification-popup">
            <div className="popup-header">
              <h2>Pending Tickets</h2>
              <BiX 
                className="close-popup" 
                onClick={togglePopup} 
                size={24} 
                style={{ cursor: 'pointer' }}
              />
            </div>
            <div className="popup-content">
              {isLoading ? (
                <p>Loading tickets...</p>
              ) : isError ? (
                <p>Error loading tickets</p>
              ) : ticketList && ticketList.total > 0 ? (
                <ul>
                  {ticketList.tickets.map((ticket, index) => (
                    <li key={index}>Ticket ID: {ticket}</li>
                  ))}
                </ul>
              ) : (
                <p>No pending tickets</p>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default ContentHeader